<template>
    <div class="w-full flex flex-col p-8 text-ternary bg-gradient-to-br from-gray-100 to-blue-50">
        <div v-if="isMerged">

            <div v-if="mergedItem.initiation" class="flex flex-col border border-ternary mb-8">
                <h1 class="text-2xl font-bold bg-ternary text-white px-4 py-2">Event Details</h1>
                <div class="p-8 bg-white">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Event</p>
                            <p class="text-lg font-semibold text-gray-900">{{ mergedItem.initiation.event }}</p>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Purpose of the Event</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.purpose_of_event }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Speaker / Representative</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.speaker }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Start Date</p>
                            <p class="text-lg font-semibold text-gray-900">{{ formatEventDateTime(mergedItem.initiation.date_time) }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">End Date</p>
                            <p class="text-lg font-semibold text-gray-900">{{ mergedItem.initiation.end_date ? formatEventDateTime(mergedItem.initiation.end_date) : '-' }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Location</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.entity_location }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Target Group</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.target_group }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Age Group</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.age_group }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Requester</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.requester }}</P>
                        </div>
                        <div>
                            <p class="text-xs uppercase tracking-widest text-gray-500">Supervisor</p>
                            <p class="text-lg font-semibold text-gray-900">{{
                                mergedItem.initiation.supervisor }}</P>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col border border-ternary">
                <h1 class="text-2xl font-bold bg-ternary text-white px-4 py-2">Applicant’s Information</h1>
                <div class="flex">
                    <div class="flex-shrink-0 border-r border-ternary">
                        <img v-if="mergedItem.profile_picture_url" class="h-48 object-contain" :src="getProfilePicture">
                        <img v-else class="h-48" src="../../assets/images/default/avatar.jpg">
                    </div>
                    <div class="flex-grow flex flex-col justify-between">
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/4 font-bold border-r border-ternary px-2 py-1  flex items-center">Full Name
                            </div>
                            <div class="w-3/4 px-2 py-1  flex items-center">{{ mergedItem.fullname }}</div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Date
                                    of Birth</div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    getFormattedDate(mergedItem.date_of_birth) }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Place
                                    of Birth</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{ mergedItem.place_of_birth }}</div>
                            </div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">
                                    Current Nationality</div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    mergedItem.current_nationality }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">
                                    Previous Nationality</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{ mergedItem.previous_nationality }}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">
                                    Passport Number</div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    mergedItem.passport_number }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Place
                                    of Issue</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{ mergedItem.place_of_issue }}</div>
                            </div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Date
                                    of Issue</div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    getFormattedDate(mergedItem.date_of_issue) }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Date
                                    of Expiry</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{
                                    getFormattedDate(mergedItem.date_of_expiry) }}</div>
                            </div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">
                                    Marital Status</div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    mergedItem.marital_status }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">
                                    Religion</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{ mergedItem.religion }}</div>
                            </div>
                        </div>
                        <div class="flex flex-row border-b border-ternary flex-grow">
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Sect
                                </div>
                                <div class="w-1/2 border-r border-ternary px-2 py-1  flex items-center">{{
                                    mergedItem.sect }}</div>
                            </div>
                            <div class="w-1/2 flex flex-row">
                                <div class="w-1/2 font-bold border-r border-ternary px-2 py-1  flex items-center">Mother
                                    Tongue</div>
                                <div class="w-1/2 px-2 py-1  flex items-center">{{ mergedItem.mother_tongue }}</div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-grow">
                            <div class="w-1/4 font-bold border-r border-ternary px-2 py-1  flex items-center">Other
                                Languages Known</div>
                            <div class="w-3/4 px-2 py-1  flex items-center">{{ mergedItem.other_languages_known }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="6" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Parent's Information</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Father's Name</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.father_name }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Nationality</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.father_nationality }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Profession</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.father_profession }}</td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Employer</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.father_employer }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Date of Birth</td>
                            <td class="py-2 px-4 border border-ternary">{{
                                getFormattedDate(mergedItem.father_date_of_birth) }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Place of Birth</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.father_place_of_birth }}</td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Mother's Name</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.mother_name }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Nationality</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.mother_nationality }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Profession</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.mother_profession }}</td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Employer</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.mother_employer }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Date of Birth</td>
                            <td class="py-2 px-4 border border-ternary">{{
                                getFormattedDate(mergedItem.mother_date_of_birth) }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Place of Birth</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.mother_place_of_birth }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="6" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Academic Qualifications
                                </h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="6" class="m-0 p-0 border border-ternary">
                                <table class="min-w-full">
                                    <tbody>
                                        <tr>
                                            <td style="width: 25%;"
                                                class="py-2 px-4 border-r  border-ternary font-bold">Highest
                                                Qualification</td>
                                            <td style="width: 25%;" class="py-2 px-4 border-r border-ternary">{{
                                                mergedItem.highest_qualification }}</td>
                                            <td style="width: 25%;" class="py-2 px-4 border-r border-ternary font-bold">
                                                Major</td>
                                            <td style="width: 25%;" class="py-2 px-4">{{ mergedItem.major }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Institution
                            </td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{ mergedItem.institution
                                }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Country</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.academic_qualification_country }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Year</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.academic_qualification_year }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="8" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Military Service</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="8" class="m-0 p-0 border border-ternary">
                                <table class="min-w-full">
                                    <tbody>
                                        <tr>
                                            <td style="width: 75%;" class="py-2 px-4 border-r border-ternary font-bold">
                                                Have you ever been in the military services?</td>
                                            <td style="width: 25%;" class="py-2 px-4">{{ mergedItem.is_military_service
                                                }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary font-bold">Country</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.military_service_country }}</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary font-bold">Type of Service
                            </td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.military_service_type_of_service }}</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary font-bold">Rank</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.military_service_rank }}</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary font-bold">Duration</td>
                            <td style="width: 12.5%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.military_service_duration }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="6" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Sponsorship Details in
                                    United Arab Emirates</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="6" class="m-0 p-0 border border-ternary">
                                <table class="min-w-full">
                                    <tbody>
                                        <tr>
                                            <td style="width: 25%;"
                                                class="py-2 px-4 border-r border-b  border-ternary font-bold">Initial
                                                Port of Entry to UAE</td>
                                            <td style="width: 25%;" class="py-2 px-4 border-r border-b border-ternary">
                                                {{ mergedItem.initial_port_of_entry }}</td>
                                            <td style="width: 25%;"
                                                class="py-2 px-4 border-r border-b border-ternary font-bold">Initial
                                                Date of Entry</td>
                                            <td style="width: 25%;" class="py-2 px-4 border-b border-ternary">{{
                                                getFormattedDate(mergedItem.initial_date_of_entry) }}</td>
                                        </tr>
                                        <tr>
                                            <td style="width: 25%;"
                                                class="py-2 px-4 border-r  border-ternary font-bold">Initial Employer
                                            </td>
                                            <td style="width: 25%;" class="py-2 px-4 border-r border-ternary">{{
                                                mergedItem.initial_employer }}</td>
                                            <td style="width: 25%;" class="py-2 px-4 border-r border-ternary font-bold">
                                                Initial Job Title</td>
                                            <td style="width: 25%;" class="py-2 px-4">{{ mergedItem.initial_job_title }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Current Sponsor
                            </td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.current_sponsor }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Current
                                Residency No</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.current_residency_number }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">UID No</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{ mergedItem.uid_number
                                }}</td>
                        </tr>
                        <tr>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Place of Issue
                            </td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.sponsorship_details_place_of_issue }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Date of Issue
                            </td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                getFormattedDate(mergedItem.sponsorship_details_date_of_issue) }}</td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary font-bold">Date of Expiry
                            </td>
                            <td style="width: 16.67%;" class="py-2 px-4 border border-ternary">{{
                                getFormattedDate(mergedItem.sponsorship_details_date_of_expiry) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="6" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Current Employment
                                    Information</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="4" class="m-0 p-0 border border-ternary">
                                <table class="min-w-full">
                                    <tbody>
                                        <tr>
                                            <td style="width: 50%;"
                                                class="py-2 px-4 border-r  border-ternary font-bold">Employment Status
                                            </td>
                                            <td style="width: 50%;" class="py-2 px-4 border-r border-ternary">{{
                                                mergedItem.employment_status }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary font-bold">Current Employer
                            </td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.current_employer }}</td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary font-bold">Current / Last Job
                                Title</td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.current_or_last_job_title }}</td>
                        </tr>
                        <tr>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary font-bold">Employer Sector
                            </td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.employer_sector }}</td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary font-bold">City / Country
                            </td>
                            <td style="width: 25%;" class="py-2 px-4 border border-ternary">{{
                                mergedItem.current_employment_city_or_country }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="8" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Residence Information in
                                    United Arab Emirates</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Proprietor</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_proprietor }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">City</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_city }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Zone</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_zone }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Street</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_street }}</td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">House / Building No</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_house }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Floor No</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_floor_no }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Tel / Mobile</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_tel }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">P.O.Box</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_uae_po_box }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="8" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Residence Information in
                                    Home Country</h1>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">Proprietor</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_proprietor
                                }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">City</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_city }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Zone</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_zone }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">Street</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_street }}
                            </td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary font-bold">House / Building No</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_house }}
                            </td>
                            <td class="py-2 px-4 border border-ternary font-bold">Floor No</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_floor_no }}
                            </td>
                            <td class="py-2 px-4 border border-ternary font-bold">Tel / Mobile</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_tel }}</td>
                            <td class="py-2 px-4 border border-ternary font-bold">P.O.Box</td>
                            <td class="py-2 px-4 border border-ternary">{{ mergedItem.res_info_home_country_po_box }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="overflow-x-auto mt-8">
                <table class="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr class="bg-ternary">
                            <th colspan="4" class="border border-ternary">
                                <h1 class="text-2xl font-bold text-white text-left px-4 py-2">Submitted Documents</h1>
                            </th>
                        </tr>
                        <tr>
                            <th class="py-2 px-4 border border-ternary text-center">#</th>
                            <th class="py-2 px-4 border border-ternary">Document</th>
                            <th class="py-2 px-4 border border-ternary text-center">View</th>
                            <th class="py-2 px-4 border border-ternary text-center">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="py-2 px-4 border border-ternary text-center">1</td>
                            <td class="py-2 px-4 border border-ternary">Signature</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye @click.stop="setDocumentPreview('Signature', mergedItem.signature_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.signature_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary text-center">2</td>
                            <td class="py-2 px-4 border border-ternary">Passport</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye @click.stop="setDocumentPreview('Passport', mergedItem.passport_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.passport_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="isVisaRequired">
                            <td class="py-2 px-4 border border-ternary text-center">3</td>
                            <td class="py-2 px-4 border border-ternary">Visa</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye @click.stop="setDocumentPreview('Visa', mergedItem.visa_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.visa_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 4 : 3 }}</td>
                            <td class="py-2 px-4 border border-ternary">Emirates ID</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye
                                        @click.stop="setDocumentPreview('Emirates ID', mergedItem.emirates_id_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.emirates_id_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr
                            v-if="mergedItem.application_type === 'Company' && mergedItem.purpose_of_request === 'Signing Agreement / MOU'">
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 5 : 4 }}</td>
                            <td class="py-2 px-4 border border-ternary">Trade License</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div v-if="mergedItem.trade_license_url" class="flex justify-center">
                                    <icon-eye
                                        @click.stop="setDocumentPreview('Trade License', mergedItem.trade_license_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                                <div v-else class="flex justify-center">
                                    Not uploaded
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div v-if="mergedItem.trade_license_url" class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.trade_license_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                                <div v-else class="flex justify-center">
                                    Not uploaded
                                </div>
                            </td>
                        </tr>
                        <tr v-if="mergedItem.application_type === 'Individual'">
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 5 : 4 }}</td>
                            <td class="py-2 px-4 border border-ternary">Academic Qualification</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye
                                        @click.stop="setDocumentPreview('Academic Qualification', mergedItem.academic_qualification_certificate_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.academic_qualification_certificate_url)"
                                        target="_blank" class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="mergedItem.application_type === 'Individual'">
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 6 : 5 }}</td>
                            <td class="py-2 px-4 border border-ternary">Employment Card</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye
                                        @click.stop="setDocumentPreview('Employment Card', mergedItem.employment_card_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.employment_card_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="mergedItem.application_type === 'Individual'">
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 7 : 6 }}</td>
                            <td class="py-2 px-4 border border-ternary">CV</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye @click.stop="setDocumentPreview('CV', mergedItem.cv_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.cv_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="mergedItem.application_type === 'Individual'">
                            <td class="py-2 px-4 border border-ternary text-center">{{ isVisaRequired ? 8 : 7 }}</td>
                            <td class="py-2 px-4 border border-ternary">Copy of the content presented</td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <icon-eye
                                        @click.stop="setDocumentPreview('Copy of the content presented', mergedItem.content_presented_url)"
                                        class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                </div>
                            </td>
                            <td class="py-2 px-4 border border-ternary">
                                <div class="flex justify-center">
                                    <a :href="getSrcFile(mergedItem.content_presented_url)" target="_blank"
                                        class="flex justify-center">
                                        <icon-download class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-download>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <div v-if="isMerged && showApproveRejectBtn" class="flex justify-center items-center mt-8">
            <div v-if="hasSuperPermission('security-clearance-reject')" @click.stop="rejectItem"
                class="mr-4 flex justify-center items-center border-2 border-red-600 bg-red-600 hover:bg-white text-white hover:text-red-600 font-medium px-4 py-2 cursor-pointer">
                <icon-reject class="w-5 h-5"></icon-reject>
                <div class="ml-1">Reject</div>
            </div>
            <div v-if="hasSuperPermission('security-clearance-approve')" @click.stop="approveItem"
                class="ml-4 flex justify-center items-center border-2 border-green-600 bg-green-600 hover:bg-white text-white hover:text-green-600 font-medium px-4 py-2 cursor-pointer">
                <icon-approve class="w-5 h-5"></icon-approve>
                <div class="ml-1">Approve</div>
            </div>
        </div>

        <div v-if="hasApprovals" class="flex flex-col mt-8">
            <h1 class="text-xl font-bold underline">Approval Action</h1>
            <div class="flex flex-col mt-2">
                <div class="flex flex-col overflow-x-auto">
                    <div class="inline-block min-w-full py-2">
                        <div class="overflow-x-auto">
                            <table class="min-w-full text-left text-sm font-light">
                                <thead class="border-b font-medium dark:border-neutral-500">
                                    <tr>
                                        <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                        <th scope="col" class="px-6 py-2 text-gray-400">Fullname</th>
                                        <th scope="col" class="px-6 py-2 text-gray-400">Note</th>
                                        <th scope="col" class="px-6 py-2 text-gray-400">Action</th>
                                        <th scope="col" class="px-6 py-2 text-gray-400">Action At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in mergedItem.security_clearance_approval" :key="index"
                                        class="border-b border-dashed dark:border-neutral-500">
                                        <td class="whitespace-nowrap px-6 py-2 font-medium">{{ index + 1 }}</td>
                                        <td class="whitespace-nowrap px-6 py-2 capitalize">{{ item.user.name }}</td>
                                        <td class="whitespace-nowrap px-6 py-2">{{ item.note }}</td>
                                        <td class="whitespace-nowrap px-6 py-2">{{ getApprovalStatus(item.status) }}
                                        </td>
                                        <td class="whitespace-nowrap px-6 py-2">{{
                                            getFormattedDateWithTimeAmPm(item.created_at) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showDocumentPreview" :title="`View ${documentName}`" @close="closeDocumentPreview">
                <iframe v-if="documentPreview" :src="documentPreview" width="100%" :height="iframeHeight"
                    frameborder="0"></iframe>
            </base-full-modal>
        </transition>

        <transition name="fade" mode="out-in">
            <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
                <div class="flex flex-col">
                    <div class="flex flex-col" :class="{ invalid: !note.isValid }">
                        <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                        <div class="h-32 px-8 rounded-xl mt-2">
                            <textarea v-model.trim="note.val" @blur="clearValidity('note')" id="note"
                                :class="note.isValid ? '' : 'border-red-600'"
                                class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                        </div>
                        <transition name="form-fade" mode="out-in">
                            <p v-if="!note.isValid" class="px-8 h-4 text-xs text-red-600 ml-1">
                                {{ note.msg }}
                            </p>
                        </transition>
                    </div>
                    <div class="flex justify-end mt-4 mr-8">
                        <div @click.stop="addNoteOk"
                            class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                            OK</div>
                    </div>
                </div>
            </base-modal>
        </transition>

        <div class="h-screen flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import IconEye from "../../components/icons/IconEye.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import IconDownload from "../../components/icons/IconDownload.vue";
import { formattedDate, formattedDateWithTimeAmPm } from "../../helpers/utils";
export default {
    name: "view-security-clearance",
    emits: ["approve-item", "reject-item"],
    props: {
        item: {
            type: Object,
            required: true,
        },
        iframeHeight: {
            type: [String, Function],
            default: null,
        },
        fromInitiatedRequests: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        IconEye,
        IconApprove,
        IconReject,
        IconDownload,
    },
    created() {
        this.getSecurityClearanceForm();
    },
    data() {
        return {
            documentPreview: null,
            documentName: "",
            showDocumentPreview: false,
            note: {
                val: "",
                isValid: true,
                msg: "",
            },
            showAddNote: false,
            isLoading: false,
            isMerged: false,
            mergedItem: null,
        };
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        getStatus() {
            if (this.mergedItem.status === null) {
                return `<div class="text-yellow-600">Under Review</div>`;
            } else if (this.mergedItem.status === true) {
                return `<div class="text-green-600">Accepted</div>`;
            } else {
                const remarks = "your remarks";
                return `<div class="flex flex-col"><div class="text-red-600">Rejected</div><div>Remarks: ${remarks}</div></div>`;
            }
        },
        hasApprovals() {
            if (this.isMerged) {
                return this.mergedItem.security_clearance_approval.length > 0;
            } else {
                return false;
            }
        },
        showApproveRejectBtn() {
            if (this.mergedItem.status === null) {
                return true;
            } else {
                return false;
            }
        },
        getProfilePicture() {
            return process.env.VUE_APP_PUBLIC_URL + this.mergedItem.profile_picture_url;
        },
        isVisaRequired() {
            if (this.mergedItem.current_nationality == 'United Arab Emirates') {
                return false;
            } else {
                return true;
            }
        },
    },
    methods: {
        getSrcFile(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        async getSecurityClearanceForm() {
            if (this.item.token) {

                this.isLoading = true;

                try {

                    const { data } = await this.$apollo.query({
                        query: gql`
                            query GetSecurityClearanceForm($first: Int!, $page: Int!, $entity: String, $token: String, $from_initiated_requests: Boolean) {
                                
                                security_clearances(first: $first, page: $page, entity: $entity, token: $token, from_initiated_requests: $from_initiated_requests) {
                                    error
                                    error_code
                                    message
                                    data {
                                        fullname
                                        profile_picture_url
                                        application_type
                                        purpose_of_request
                                        status
                                        date_of_birth
                                        place_of_birth
                                        current_nationality
                                        previous_nationality
                                        passport_number
                                        place_of_issue
                                        date_of_issue
                                        date_of_expiry
                                        marital_status
                                        religion
                                        sect
                                        mother_tongue
                                        other_languages_known
                                        father_name
                                        father_nationality
                                        father_profession
                                        father_employer
                                        father_date_of_birth
                                        father_place_of_birth
                                        mother_name
                                        mother_nationality
                                        mother_profession
                                        mother_employer
                                        mother_date_of_birth
                                        mother_place_of_birth
                                        highest_qualification
                                        major
                                        institution
                                        academic_qualification_country
                                        academic_qualification_year
                                        is_military_service
                                        military_service_country
                                        military_service_type_of_service
                                        military_service_rank
                                        military_service_duration
                                        initial_port_of_entry
                                        initial_date_of_entry
                                        initial_employer
                                        initial_job_title
                                        current_sponsor
                                        current_residency_number
                                        uid_number
                                        sponsorship_details_place_of_issue
                                        sponsorship_details_date_of_issue
                                        sponsorship_details_date_of_expiry
                                        employment_status
                                        current_employer
                                        current_or_last_job_title
                                        employer_sector
                                        current_employment_city_or_country
                                        res_info_uae_proprietor
                                        res_info_uae_city
                                        res_info_uae_zone
                                        res_info_uae_street
                                        res_info_uae_house
                                        res_info_uae_floor_no
                                        res_info_uae_tel
                                        res_info_uae_po_box
                                        res_info_home_country_proprietor
                                        res_info_home_country_city
                                        res_info_home_country_zone
                                        res_info_home_country_street
                                        res_info_home_country_house
                                        res_info_home_country_floor_no
                                        res_info_home_country_tel
                                        res_info_home_country_po_box
                                        signature_url
                                        passport_url
                                        visa_url
                                        emirates_id_url
                                        trade_license_url
                                        academic_qualification_certificate_url
                                        employment_card_url
                                        cv_url
                                        content_presented_url
                                        security_clearance_approval {
                                            status
                                            note
                                            user {
                                                name
                                                email
                                            }
                                            created_at
                                        }
                                        initiation {
                                            token
                                            speaker
                                            event
                                            purpose_of_event
                                            target_group
                                            age_group
                                            date_time
                                            end_date
                                            entity_location
                                            requester
                                            supervisor
                                            send_to_email
                                        }
                                    }
                                }

                            }
                        `,
                        variables: {
                            first: 1,
                            page: 1,
                            entity: "",
                            token: this.item.token,
                            from_initiated_requests: this.fromInitiatedRequests,
                        },
                        fetchPolicy: 'network-only',
                    });

                    if (data.security_clearances.error) {
                        alert(data.security_clearances.message);
                    } else if (
                        data.security_clearances.data &&
                        data.security_clearances.data.length > 0
                    ) {
                        this.mergedItem = { ...this.item, ...data.security_clearances.data[0] };
                        this.isMerged = true;
                    }

                } catch (error) {
                    console.log(error.message);
                }

                this.isLoading = false;

            }
        },
        hasSuperPermission(crudName) {
            const permissions = this.$store.getters.permissions;
            const permissionsArray = permissions.split(",");
            if (permissionsArray.includes(crudName)) {
                return true;
            } else {
                return false;
            }
        },
        setDocumentPreview(documentName, url) {
            this.documentName = documentName;
            this.documentPreview = process.env.VUE_APP_PUBLIC_URL + url;
            this.showDocumentPreview = true;
        },
        closeDocumentPreview() {
            this.showDocumentPreview = false;
            this.documentName = "";
            this.documentPreview = null;
        },
        getApprovalStatus(status) {
            switch (status) {
                case false:
                    return 'Rejected';
                case true:
                    return 'Approved';
                default:
                    return '';
            }
        },
        getFormattedDateWithTimeAmPm(date) {
            return formattedDateWithTimeAmPm(date);
        },
        formatEventDateTime(value) {
            if (!value) {
                return '-';
            }
            try {
                return formattedDateWithTimeAmPm(value);
            } catch (_error) {
                return value;
            }
        },
        approveItem() {
            this.$emit('approve-item', this.item.token);
        },
        rejectItem() {
            this.showAddNote = true;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = {
                val: "",
                isValid: true,
                msg: "",
            };
        },
        addNoteOk() {
            if (this.note.val === "") {
                this.note.isValid = false;
                this.note.msg = "You must enter a note.";
            } else {
                this.showAddNote = false;
                this.$emit('reject-item', this.item.token, false, this.note.val);
            }
        },
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        getFormattedDate(date) {
            return formattedDate(date);
        },
        // displayValue(value) {
        //     if (value === null || value === undefined || value === '') {
        //         return '-';
        //     }
        //     return value;
        // },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.form-fade-enter-active,
.form-fade-leave-active {
    transition: all 0.5s ease;
}

.form-fade-enter-from,
.form-fade-leave-to {
    opacity: 0;
    height: 0px;
}
</style>